module.exports = __webpack_public_path__ + "img/siguiente-ele-flotante.f9f149f3.png";